/* eslint-disable jsx-a11y/anchor-has-content */
import { Link } from 'gatsby'
import * as React from 'react'

const Anchor: React.FC<any> = (props) =>
  props.href && (props.href.startsWith('http') || props.href === '#') ? (
    <a {...props} />
  ) : (
    <Link {...props} />
  )

export default Anchor
